import styled from 'styled-components';
import { Checkbox } from '@mui/material';

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
`;

const NotificationRow = styled.article<{ $showSelect: boolean }>`
  position: relative;
  display: grid;
  grid-template-columns: ${(p) => (p.$showSelect ? '80px minmax(0, 1fr) auto' : 'minmax(0, 1fr) auto')};
  gap: 20px;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding-bottom: 15px;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray100};

  @media (max-width: 639px) {
    grid-template-columns: ${(p) => (p.$showSelect ? '44px minmax(0, 1fr)' : 'minmax(0, 1fr)')};
    column-gap: 12px;
    row-gap: 12px;
  }
`;

const NotificationCheckbox = styled(Checkbox)`
  && {
    align-self: start;
    width: 100%;
  }
`;

const NotificationBody = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;

  h3 {
    overflow-wrap: anywhere;
  }
`;

const NotificationActions = styled.div`
  display: flex;
  gap: 5px;
  align-items: flex-end;
  justify-content: flex-end;
  min-width: 0;

  @media (max-width: 639px) {
    grid-column: 1 / -1;
    width: 100%;
    flex-wrap: wrap;

    > button:first-child {
      flex: 1 1 auto;
    }

    > button:last-child {
      flex: 0 0 44px;
      min-width: 44px;
      min-height: 44px;
    }
  }
`;

const Description = styled.p`
  margin-bottom: 5px;
  width: 100%;
  color: ${(p) => p.theme.colors.gray400};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 639px) {
    white-space: normal;
    overflow-wrap: anywhere;
  }
`;

const TimeDifference = styled.p`
  color: ${(p) => p.theme.colors.gray300};
`;

const UnreadDot = styled.div`
  position: absolute;
  top: 0;
  right: 5.5px;
  width: 8px;
  height: 8px;
  background: ${(p) => p.theme.colors.orange};
  border-radius: 50%;
`;

const OrangeTitle = styled.span`
  color: ${(p) => p.theme.colors.orange};

`

export {
  CardWrapper,
  Description,
  NotificationActions,
  NotificationBody,
  NotificationCheckbox,
  NotificationRow,
  TimeDifference,
  UnreadDot,
  OrangeTitle,
};
